<template>
  <div class="AttachmentsBar" :class="[isFullscreen ? 'AttachmentsBar--sm' : 'AttachmentsBar--upper']">
    <player-attachments-button
      v-if="showAttachmentsBtn"
      :currentStep="currentStep"
      :isSmallScreen="isSmallScreen"
      :showList="showList"
      @show-list="showList = true"
      @hide-list="showList = false"
    />
    <attachments-bar-list
      :showAttachmentsBar="showAttachmentsBtn && showList"
      :currentStep="currentStep"
      @hide-list="showList = false"
    />
  </div>
</template>

<script>
import PlayerAttachmentsButton from "@/components/DWorkflowPlayer/attachments/PlayerAttachmentsButton.vue";
import AttachmentsBarList from "@/components/DWorkflowPlayer/attachments/AttachmentsBarList.vue";
import { mapGetters, mapState } from "vuex";
export default {
  name: "AttachmentsBar",
  props: {
    isSmallScreen: Boolean,
    hideControls: Boolean,
    currentStep: Number,
    isEmbedDeephow: Boolean,
  },
  components: {
    PlayerAttachmentsButton,
    AttachmentsBarList,
  },
  watch: {
    getter_is_window_mode: {
      handler(getter_is_window_mode) {
        this.showList = !getter_is_window_mode;
      },
    },
    isFullscreen: {
      handler(isFullscreen) {
        this.showList = isFullscreen;
      },
    },
  },
  created() {
    this.showList = this.isFullscreen || this.isEmbedDeephow;
  },
  data() {
    return {
      showList: false,
    };
  },
  computed: {
    ...mapState("workflowPlayer", ["isFullscreen"]),
    ...mapGetters("workflowPlayer", ["getter_attachments", "getter_show_attachments_list", "getter_is_window_mode"]),
    showAttachmentsBtn() {
      return this.getter_attachments[this.currentStep] && this.getter_attachments[this.currentStep].length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.AttachmentsBar {
  --padding-left: 32px;
  --padding-top: 90px;
  z-index: 2;
  position: absolute;
  left: 0;
  top: 0;
  min-width: 240px;
  height: 100%;
  pointer-events: none;
  padding-left: var(--padding-left);
  padding-top: var(--padding-top);

  &--sm {
    --padding-left: 16px;
    --padding-top: 64px;
  }
  &--upper {
    --padding-top: 24px !important;
  }
}
</style>
